import { ENV } from '../env/base'

const { ICON_URL_GL, ICON_URL_TH } = ENV()

export interface productType {
    change24: number
    id: number
    lastPrice: number
    name: string
    volume: number
    icon: string
    Rolling24HrNotional: number
    symbol: string
}

export interface productToShowType {
    productId: number
    instrumentId: number
}

const mapSeasonRewards = (products: Product[], season: Season) => {
    let seasonProducts: SeasonReward[] = []
    if (
        products &&
        products.length &&
        season &&
        season.rewards &&
        season.rewards.length
    ) {
        const { rewards } = season
        const host = window.location.hostname
        const isThHost = host.includes('.co.th')
        const ICON_URL = isThHost ? ICON_URL_TH : ICON_URL_GL
        seasonProducts = rewards.map((item: Reward) =>
            products.reduce(
                (acc: any, cur: Product) =>
                    cur.ProductId === item.product_id
                        ? (acc = Object.assign({
                              ...item,
                              ...cur,
                              icon: `${ICON_URL}/${cur.Product.toLowerCase()}-48px.svg`,
                          }))
                        : acc,
                { error: 'not found' }
            )
        )
    }
    return seasonProducts
}

export const COIN_UTIL = {
    mapSeasonRewards,
}
